import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import TeeTimePaymentMethodMix from "../../../assets/components/reports/TeeTimePaymentMethodMix";

class MemberTeeTimePaymentMethodMixReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Tee-Time Payment Method Mix</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <TeeTimePaymentMethodMix />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default MemberTeeTimePaymentMethodMixReport;
